import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import "katex/dist/katex.min.css";
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { useDispatch, useSelector } from 'react-redux';
import { latexAction } from '../../redux/extraReducers/latex';

interface ViewLatexActionProps {
  actionValue: any;
  result?: any;
}

export default function ViewLatexAction({ actionValue, result }: ViewLatexActionProps) {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const cardKey = actionValue[0].config_details.id;
  const paragraphContent = actionValue?.[0]?.config_details?.default_value;
  const dispatch = useDispatch<AppDispatch>();
  const taskData = result?.tasks?.[0] || {};

  const latexDocumentLink = useSelector(
    (state: RootState) => state.latexDocument.documents?.[cardKey]
  );

  const latexUrl = latexDocumentLink?.url || "";

  useEffect(() => {
    const generatePdf = async () => {
      if (!paragraphContent || !cardKey || !taskData?.task_allocation_id) return;

      const payload = {
        latex: paragraphContent,
        alloc_id: taskData.task_allocation_id,
        config_id: cardKey,
      };
      try {
        setIsPreviewLoading(true);
        await dispatch(latexAction(payload)).unwrap();
      } catch (error) {
        console.error("Save failed:", error);
        setErrorMsg("Preview failed. Please try again.");
      } finally {
        setIsPreviewLoading(false);
      }
    };

    generatePdf();
  }, [paragraphContent, cardKey, taskData?.task_allocation_id, dispatch]);

  if (!actionValue || actionValue.length === 0) {
    return <Typography>No label available.</Typography>;
  }

  return (
    <>
      {actionValue.map((value: any, valueIndex: number) => (
        <div
          key={valueIndex}
          style={{
            height: "100vh",
            backgroundColor: "#fff",
            color: "#000",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography sx={{ fontWeight: 'bold', marginBottom: '10px' }}>
            {value?.config_details?.value?.title}:
          </Typography>

          <div style={{ display: "flex", flex: 1, overflow: "auto" }}>
            <div style={{ flex: 1, padding: "10px", overflowY: "auto" }}>
              <h3 style={{ color: "#66ff99" }}>Output</h3>
              
              {errorMsg ? (
                <Typography color="error">{errorMsg}</Typography>
              ) : isPreviewLoading ? (
                <Typography>Loading PDF preview...</Typography>
              ) : latexUrl ? (
                <iframe
                  src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(latexUrl)}`}
                  style={{ width: "100%", height: "100%", border: "none" }}
                  title="PDF Preview"
                />
              ) : (
                <Typography>No preview available.</Typography>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
